export var EventTypes;
(function (EventTypes) {
    EventTypes["UPDATE"] = "UPDATE";
    EventTypes["UPDATE_SHARED_FILTERS"] = "UPDATE_SHARED_FILTERS";
    EventTypes["GLOBAL_SEARCH_CHANGE"] = "ksys-global-search-change";
    EventTypes["GLOBAL_INPUTS_CHANGE"] = "ksys-global-inputs-change";
    EventTypes["APP_INITIALIZED"] = "ksys-app-initialized";
    EventTypes["PAGINATION_CHANGE"] = "ksys-on-pagination-change";
    EventTypes["UPDATE_PAGINATION"] = "ksys-update-pagination";
    EventTypes["CHANGE_ATTESTATION"] = "ksys-change-attestation";
    EventTypes["APPLY_FILTERS"] = "ksys-apply-filters";
})(EventTypes || (EventTypes = {}));
//# sourceMappingURL=EventTypes.js.map